import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-btn-toggle',
  templateUrl: './btn-toggle.component.html',
  styleUrls: ['./btn-toggle.component.scss']
})
export class BtnToggleComponent implements OnInit {
  
  @Input() btnId: string;
  @Input() btnOnLabel: string;
  @Input() btnOffLabel: string;
  @Input() btnValue: boolean;
  @Input() btnDisabled:boolean;
  @Output() btnOnclick: EventEmitter<boolean> = new EventEmitter();
  constructor() {
  }

  ngOnInit(): void {
  }

  onBtnClick(): void {
    if(!this.btnDisabled){
      this.btnValue = !this.btnValue;
      this.btnOnclick.emit(this.btnValue);
    }
  }

}
